module.exports = __webpack_public_path__ + "static/media/back-button.32eabc72.png";